import {Header} from "#/src/pages/blog/Header";
import {Content} from "#/src/pages/blog/Content";
import {useEffect, useState} from "react";
import AppConstants from "#/src/utils/app-constants";
import {composeHeaders, composeQuery} from "#/src/utils/api-request-utils";
import {usePageContext} from "vike-react/usePageContext";
import {AppPageContext, PaginatedRequest} from "#/src/definitions/AppDefinitions";
import {toast} from "react-toastify";
import {LiveStreamersHeader} from "#/src/components/LiveStreamersHeader";
import {ApiArticle} from "#/src/definitions/ApiDefinitions";

export {Page}

function Page() {
  const pageContext = usePageContext() as AppPageContext;
  const [query, setQuery] = useState<string | null>(null);
  const [page, setPage] = useState(1);
  const [queryData, setQueryData] = useState({isPending: true, error: false, pageData: null});
  useEffect(() => {
    if (query == null || query === "") {
      return;
    }
    setQueryData({...queryData, isPending: true});
    const queryParams = composeQuery({query, page});
    onFetch(queryParams);
  }, [query]);
  async function onFetch(queryParams: string) {
    return fetch(`${AppConstants.API_ROUTE}/blog/search?${queryParams}`, {
      method: "GET",
      headers: composeHeaders(pageContext)
    }).then(async response => {
      const page = await response.json() as PaginatedRequest<ApiArticle>;
      const currentData = queryData.pageData || {data: [], page: 1, maxPages: 1};
      const newData = currentData.data.concat(page.data);
      setQueryData({...queryData, isPending: false, pageData: {...currentData, data: newData, page: page.page, maxPages: page.maxPages}});
    }).catch(async response => {
      const errorResponse = await response.json() as any;
      if (errorResponse && errorResponse.errors) {
        errorResponse.errors.forEach(err => toast(err));
      }
    });
  }
  async function onQuery(value: string) {
    setQuery(value);
    setQueryData({...queryData, pageData: {data: [], page: 1, maxPages: 1, isPending: true}});
  }
  async function onPageFetch() {
    const newPage = page + 1;
    setPage(newPage);
    const queryParams = composeQuery({query, page: newPage});
    return onFetch(queryParams);
  }
  return <>
    <LiveStreamersHeader/>
    <Header onQuery={onQuery}/>
    <Content query={{enabled: (query != null && query !== ""), isPending: queryData.isPending, error: queryData.error, pageData: queryData.pageData}} onPageFetch={onPageFetch}/>
  </>
}
